module.exports = __webpack_public_path__ + "static/media/close.f0f3fb86.svg";